<template>
  <select :name="name" v-on:input="updateValue($event.target.value)">
    <option value="">- Select -</option>
    <option
      v-for="option in options"
      :value="option[valueField || 'id']"
      v-bind:selected="option[valueField || 'id'] == value"
    >{{option[titleField || 'title']}}</option>
  </select>
</template>

<script>
/* global */
export default {
  name: 'select-input',
  props: ['name', 'value', 'options', 'valueField', 'titleField'],
  data () {
    return {
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
</style>



// WEBPACK FOOTER //
// select-input.vue?7dbee2f0